import { Matcher } from '@yext/search-headless-react';
import { isNumberRangeValue } from '../utils/filterutils';
export function isNumberRangeFilter(unknownFilter = {}) {
    const filter = unknownFilter;
    return (filter.matcher === Matcher.Between) && isNumberRangeValue(filter.value);
}
//# sourceMappingURL=NumberRangeFilter.js.map